module.exports = __webpack_public_path__ + "media/img/frontend_application/stats/icon-opened-e7be2c092c2581f8f4d30c7c003301fc.png";